import React from 'react';
import clsx from 'clsx';

export const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      className={clsx(
        'flex min-h-[120px] w-full rounded-[var(--radius-sm)] border border-[var(--muted)] bg-white px-3 py-2 text-sm',
        'placeholder:text-[var(--fg)]/50',
        'focus:outline-none focus:ring-2 focus:ring-[var(--ring)] focus:ring-offset-1',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'resize-none transition-shadow duration-200',
        className
      )}
      ref={ref}
      data-testid={props['data-testid'] || 'textarea'}
      {...props}
    />
  );
});

Textarea.displayName = 'Textarea';